class StickyBuyButton extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    const addToCart = document.querySelector('.buy-buttons-block');
    if (!addToCart) return;
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.setAttribute("aria-hidden", String(entry.isIntersecting))
      }, { threshold: 0 }
    );
    this.observer.observe(addToCart);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-buy-button', StickyBuyButton);
